import { FC } from 'react'
import { LeafletMap } from './LeafletMap'

const MapPage: FC = () => <LeafletMap />

export { MapPage }
